module.exports = __webpack_public_path__ + "media/images/wines/magnum/bottle-6712b398c260c7223105cf4680c39b6f.png";